<ex-badge icon="file-filled"
          [text]="'tenders.badge.' + tenderType | translate"
          backgroundColor="var(--basic-250)"
          color="var(--basic-600)"
          borderColor="10%"
/>
